module.exports = __webpack_public_path__ + "img/02-pic.32096939.png";